import * as R from 'ramda';

import { AssetDetail } from '@atom/types/asset';

export enum InventoryDetailActionType {
  SET_ASSET = 'SET_ASSET',
  UPDATE_ASSET_PROPERTY = 'UPDATE_ASSET_PROPERTY',
}

export type SetAssetAction = {
  type: InventoryDetailActionType.SET_ASSET;
  data: AssetDetail;
};

export type UpdateAssetPropertyAction = {
  type: InventoryDetailActionType.UPDATE_ASSET_PROPERTY;
  data: {
    property: keyof AssetDetail;
    value: any;
  };
};

export type InventoryDetailAction = SetAssetAction | UpdateAssetPropertyAction;

export const initialAsset = {} as AssetDetail;

// Only rename passes `includeCursor: true`, so most mutation responses come
// back without a cursor; keep the last known cursor for the same asset so
// header pagination survives those writes.
const setAsset = (state: AssetDetail, action: SetAssetAction): AssetDetail => {
  const asset = action.data;
  const preserveCursor = state.id === asset.id && !asset.cursor;

  return {
    ...asset,
    cursor: preserveCursor ? state.cursor : asset.cursor,
  };
};

const updateAssetProperty = (
  state: AssetDetail,
  action: UpdateAssetPropertyAction,
): AssetDetail =>
  R.set(R.lensPath([action.data.property]), action.data.value, state);

const inventoryDetailReducer = (
  state: AssetDetail,
  action: InventoryDetailAction,
): AssetDetail => {
  switch (action.type) {
    case InventoryDetailActionType.SET_ASSET:
      return setAsset(state, action);
    case InventoryDetailActionType.UPDATE_ASSET_PROPERTY:
      return updateAssetProperty(state, action);
    default: {
      return state;
    }
  }
};

export default inventoryDetailReducer;
